<template>
  <div class="body-box marginBox">
    <!-- 搜索与添加区域 -->
    <el-row class="plan">
      <el-col :span="19">
        <el-button icon="el-icon-plus" @click="addDialogVisible = true">新增</el-button>
      </el-col>
      <el-col :span="5">
        <search-input v-model="queryInfo.key" placeholder="请输入关键字进行搜索" @change="searchHandleQuery" />
      </el-col>
    </el-row>


    <el-table :height="'calc(100% - 70px)'" :data="dictList" class="button-box">
      <el-table-column label="字典名称" prop="name"></el-table-column>
      <el-table-column label="字典关键字" prop="keyword"></el-table-column>
      <el-table-column label="内容" prop="value"></el-table-column>
      <el-table-column label="操作" width="180px">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" @click="editDict(scope.row)">修改</el-button>
          <el-button icon="el-icon-delete" @click="removeDictById(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页区域 -->
    <div class="fixedBox"><pagination ref='page' :query-param.sync='queryInfo' @pagination="getDictList" /></div>


    <!-- 添加字典对话框 -->
    <el-dialog
      title="添加字典"
      :visible.sync="addDialogVisible"
      width="40%"
      append-to-body
      @close="addDialogClosed"
    >
      <el-form
        ref="addFormRef"
        :model="addForm"
        :rules="rules"
        label-width="120px"
      >
        <el-row>
          <el-col :span="24">
            <el-alert title="创建一级菜单不需要选择上级菜单" type="warning" style="margin-bottom: 20px"></el-alert>
            <el-form-item label="选择上级菜单" prop="name">
              <el-select style="width: 100%;" v-model="addForm.pid" placeholder="请选择">
                <el-option
                  v-for="item in dictList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="字典名称" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入字典名称" />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="内容" prop="value">
              <el-input v-model="addForm.value" placeholder="请输入内容" />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="关键字" prop="keyword">
              <el-input
                v-model="addForm.keyword"
                placeholder="请输入关键字"
                maxlength="32"
              />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="说明" prop="describe">
              <el-input
                v-model="addForm.describe"
                placeholder="请输入说明"
                maxlength="32"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button @click="addDict">确 定</el-button>
      </div>
    </el-dialog>


    <!-- 修改字典对话框 -->
    <el-dialog
      title="修改字典"
      :visible.sync="editOpen"
      width="30%"
    >
      <el-form ref="addFormRef" :rules="rules" :model="editForm" label-width="80px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="字典名称" prop="name">
              <el-input v-model="editForm.name" placeholder="请输入字典名称" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="内容" prop="value">
              <el-input v-model="editForm.value" placeholder="请输入内容" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="关键字" prop="keyword">
              <el-input
                v-model="editForm.keyword"
                placeholder="请输入备注"
                maxlength="11"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="describe">
              <el-input
                v-model="editForm.describe"
                placeholder="请输入说明"
                maxlength="11"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editOpen = false">取 消</el-button>
        <el-button @click="modifyDict">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '@/components/common/Pagination'
import { getData, getPostOrDeleteData } from '@/utils/code'
import { addDict, deleteDict, getDictList, selectDictByKey, updateDict } from '@/api/user/dict/dict'
import { deleteTips, title } from '@/utils/tips'
import SearchInput from '@/components/common/searchInput/searchInput'
import { dictRules } from '@/js/rules'

export default {
  components: { SearchInput, Pagination },
  data() {
    return {
      queryInfo: {
        key: ''
      },
      dictList: [],
      addDialogVisible: false,
      editOpen: false,
      addForm: {}, //添加组织表单
      editForm: {}, //修改
      rules: dictRules
    }
  },
  created() {
    this.handleQuery()
  },
  methods: {
    handleQuery() {
      this.$nextTick(() => {
        this.$refs.page.run()
      })
    },

    // 所有列表
    getDictList(page, cb) {
      getDictList(page).then((response) => {
        this.dictList = cb(response)
      })
    },

    // 监听添加用户对话框的关闭事件 /  重置表单
    addDialogClosed() {
      this.addForm = {}
    },


    // 添加
    addDict() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        addDict(this.addForm).then((response) => {
          let data = getData(response)
          if (data !== null) {
            this.handleQuery()
            this.addDialogVisible = false
          }
        })
      })
    },

    // 删除
    async removeDictById(id) {
      let b = await deleteTips(title.deleteTitle)
      if (b) {
        deleteDict(id).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.handleQuery()
          }
        })
      }
    },

    // 修改
    editDict(row) {
      this.editForm = JSON.parse(JSON.stringify(row))
      this.editOpen = true
    },

    modifyDict() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        updateDict(this.editForm.id, this.editForm).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.handleQuery()
            this.editOpen = false
          }
        })
      })
    },

    // 查询
    getHande() {
      selectDictByKey(this.queryInfo.key).then((response) => {
        this.dictList = getData(response) ? getData(response) : []
      })
    },

    /** 搜索按钮操作 */
    searchHandleQuery() {
      if (this.queryInfo.key === '') {
        this.handleQuery()
      } else {
        this.getHande()
      }
    }

  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  padding-right: 30px;

  .el-input__inner {
    height: 36px;
    line-height: 36px;
  }
}
</style>
